













































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

// Supported input types
import InputType from './inputs/types';

// The actual input component
import InputComponent from './InputComponent.vue';

@Component({
    components: {
        InputComponent,
    },
})
export default class Input extends Vue {

    @Prop({ type: String, required: true })
    private type!: InputType;

    @Prop({ type: String, required: true })
    private name!: string;

    @Prop({ required: true })
    private value!: unknown;

    @Prop({ type: String })
    private description!: number;

    @Prop({ type: String })
    private symbol!: number;

    @Prop()
    private error!: string | boolean;

    /**
     *  Getter and setter to forward the v-model
     *  binding to the input component.
     */
    private get model(): unknown {

        return this.value;

    }

    private set model(value: unknown) {

        this.$emit('input', value);

    }

    /**
     *  Used to get the error message, implemented
     *  because an error can also be a boolean for
     *  showing the orange border on error.
     */
    private get errorMessage(): string | null {

        return typeof this.error === 'string' ? this.error : null;

    }

}
